import React from 'react';
import PropTypes from 'prop-types';
import Label from "../Label";
import common from "../../../../common/common";
import styles from './index.module.scss';

class Card extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showHoverWrap: false // 是否展示hover弹层
        }
    }

    static defaultProps = {
        className: '',
        cover: '',
        meta: null,
        footer: null,
        label: {},
        hoverable: true,
        hoverContent: null
    };

    static propTypes = {
        className: PropTypes.string, // Card外层容器类名
        cover: PropTypes.string, // 封面图
        // Card信息
        meta: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.node
        ]),
        // Card底部信息
        footer: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.node
        ]),
        label: PropTypes.object, // 右上角标签相关信息  visible-是否展示  style-标签样式  text-文案
        hoverable: PropTypes.bool, // 是否有hover状态
        // hover遮罩层内容
        hoverContent: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.node
        ])
    };

    componentDidMount() {
    }

    // 移动端点击Card
    onCardClick = (e) => {
        this.cancelBubble(e);

        if (!this.props.hoverable || !common.isMobileShell()) return;
        this.setState((prevState) => ({
            showHoverWrap: !prevState.showHoverWrap
        }))
    };

    // PC端鼠标移入Card
    onCardMouseEnter = (e) => {
        this.cancelBubble(e);

        if (!this.props.hoverable || common.isMobileShell()) return;

        if (!this.state.showHoverWrap) {
            this.setState({
                showHoverWrap: true
            })
        }
    };

    // PC端鼠标移出Card
    onCardMouseLeave = (e) => {
        this.cancelBubble(e);

        if (!this.props.hoverable || common.isMobileShell()) return;

        if (this.state.showHoverWrap) {
            this.setState({
                showHoverWrap: false
            })
        }
    };

    // 阻止事件冒泡
    cancelBubble = (e) => {
        e.stopPropagation();
    };


    render() {
        const {
            className,
            cover,
            meta,
            footer,
            label,
            hoverable,
            hoverContent
        } = this.props;

        const { visible = false, style = {}, text = '' } = label;

        const { showHoverWrap } = this.state;

        return (
            <div
                className={`card-info-container ${className} ${hoverable ? 'card-hoverable' : ''}`}
                onClick={this.onCardClick}
                onMouseEnter={this.onCardMouseEnter}
                onMouseLeave={this.onCardMouseLeave}
            >
                {/*卡片内容 start*/}
                <div className="card-info-wrap">
                    <div className="card-info-inner">
                        <div className="card-main-info">
                            <div className="cover" style={{backgroundImage: `url("${cover}")`}}/>
                            {
                                meta && <div className="meta">
                                    {
                                        meta
                                    }
                                </div>
                            }
                        </div>
                        {
                            footer && <div className="card-other-info clearfix">
                                {
                                    footer
                                }
                            </div>
                        }
                    </div>
                </div>
                {/*卡片内容 end*/}

                {/*角签 start*/}
                {
                    visible &&
                    <Label
                        style={style}
                        label={text}
                    />
                }
                {/*角签 end*/}

                {/*hover 遮罩层 start*/}
                {
                    hoverable && hoverContent && <div className={`card-hover-wrap ${showHoverWrap ? 'show' : ''}`}>{hoverContent}</div>
                }
                {/*hover遮罩层 end*/}
            </div>
        )
    }
}
export default Card;